export default __webpack_public_path__ + "static/media/icon.edc1bbf1.svg";